import React from 'react';
import { useTranslation } from 'react-i18next';
import { Shield } from 'lucide-react';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { AccordionContent, AccordionItem, AccordionTrigger } from '../ui/accordion';

const AbsenceRestrictionsAccordion = ({ formData, updateField }) => {
  const { t } = useTranslation();

  return (
  <AccordionItem value="restrictions">
    <AccordionTrigger>
      <div className="flex items-center gap-2">
        <Shield className="h-5 w-5" />
        {t('absenceReasons.form.restrictionsTitle')}
      </div>
    </AccordionTrigger>
    <AccordionContent className="space-y-4 pt-4">
      <div className="space-y-2">
        <Label htmlFor="restricted_to_gender">{t('absenceReasons.form.genderRestriction')}</Label>
        <Select
          value={formData.restricted_to_gender || 'none'}
          onValueChange={(v) => updateField('restricted_to_gender', v === 'none' ? null : v)}
        >
          <SelectTrigger><SelectValue placeholder={t('absenceReasons.form.noRestriction')} /></SelectTrigger>
          <SelectContent>
            <SelectItem value="none">{t('absenceReasons.form.noRestriction')}</SelectItem>
            <SelectItem value="MALE">{t('absenceReasons.form.menOnly')}</SelectItem>
            <SelectItem value="FEMALE">{t('absenceReasons.form.womenOnly')}</SelectItem>
          </SelectContent>
        </Select>
      </div>

      <div className="space-y-2">
        <Label htmlFor="min_seniority_months">{t('absenceReasons.form.minSeniority')}</Label>
        <Input
          id="min_seniority_months"
          type="number"
          min="0"
          value={formData.min_seniority_months}
          onChange={(e) => updateField('min_seniority_months', parseInt(e.target.value))}
        />
      </div>
    </AccordionContent>
  </AccordionItem>
  );
};

export default AbsenceRestrictionsAccordion;
